import { devLog } from '../../../../utils/browser';
import { RequestError, sendErrorToDataLayer } from './error';

/**
 *
 * @param {Response | Promise<Response>} response
 */
export async function handleFetchResponse(input) {
  const response = await input;
  const data = await response.json();

  if (!response.ok) {
    devLog('--------------- handleFetchResponse', response);
    const error = RequestError.withData(data, `Request failed with status ${response?.status}`);
    sendErrorToDataLayer(error);
    throw error;
  }

  return data;
}

export function getApiUrl(path) {
  return `${process.env.NEXT_PUBLIC_API_ENERGIA_SOLAR}/${path}`.replace(/([^:]\/)\/+/g, '$1');
}
